import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

export type Events = {
    submittingAndRedirecting: undefined;
    'redirecting:abort': undefined;
};

export const eventBus = createEventBus<Events>();
